<template>
  <div class="content" v-if="activeUser">
    <h2 class="head">
      {{activeUser.firstName}}
      <!-- {{$ml.get(`dashboard`)}} -->
      <app-btn @click="toDashboard" styling="outline">
        {{$ml.get(`Back`)}}
      </app-btn>
    </h2>
    <div class="info">
      <General />
      <changePass />
      <action />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import General from '@/components/subAccount/details/general'
import changePass from '@/components/subAccount/details/changePass'
import action from '@/components/subAccount/details/action'

export default {
  data () {
    return {

    }
  },
  computed: {
    ...mapGetters({
      activeUser: 'subAccount/activeUser',
    })
  },
  components: {
    General,
    changePass,
    action
  },
  methods: {
    toDashboard () {
      this.$router.push('/dashboard/sub-accounts/' + this.$route.params.subId);
    }
  },
}
</script>

<style lang="scss" scoped>
  .content {
    width: calc(100% - 300px);
    height: 100%;
    display: flex;
    flex-direction: column;

    .head {
      text-align: start;
      font-style: normal;
      font-weight: bold;
      font-size: 33px;
      color: #4C5056;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin: 12px 0;

      @media (max-width: 560px) {
        flex-direction: column;
        
        > button {
          margin: 20px 0;
        }
      }
    }
    .info {
      height: 100%;
      width: 100%;
      background: white;
      border-radius: 5px;
      padding: 24px 16px;
      display: flex;
      flex-direction: column;

      .viewAll {
        border-bottom: 0.7px solid #E4E5E6;
        // border-top: 0.7px solid #E4E5E6;
        width: 100%;
        height: 66px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 40px;
      }
    }
  }
</style>
